import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Player.css";
import PropTypes from "prop-types";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import RepeatIcon from "@material-ui/icons/Repeat";
import RepeatOneIcon from "@material-ui/icons/RepeatOne";
import PauseIcon from "@material-ui/icons/Pause";
import IconButton from "@material-ui/core/IconButton";
import {
  playAudio,
  pauseAudio,
  clearAudio,
  setAudioProgress,
  setAudioBuffer,
  endAudio,
} from "redux/actions/PlayerActions";
import PlayerProgress from "./PlayerProgress/PlayerProgress";
import PlayerVolume from "./PlayerVolume/PlayerVolume";
import { loopPlay, unloopPlay } from "redux/actions/PlayerActions";
import { audioError } from "../../redux/actions/PlayerActions";
import Badge from "@material-ui/core/Badge";
import DownloadLink from "./../../util/downloader/DownloadLink";
import { PlayableTypes } from "./PlayerRef/PlayerRef";
import PlayerPlaylist from "./PlayerPlaylist";
import { playPlaylistTrack, abuseMsgClose } from './../../redux/actions/PlayerActions';
import { Snackbar, CircularProgress, } from "@material-ui/core";
import { Link } from "react-router-dom";
import Confirm from "../../util/Confirm";
import { activityLimitActions } from "../../util/UserActivityLimit";
import MetaDataPopOut from "../../_module/component/metadata-popout/metadata-popout";
import clsx from "clsx";
import { getPlayerVolume } from "../../util/CommonFunc";

class Player extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const {
      player: { audioPlayer, playProgress, isBufferCompleted },
      handleSetAudioBuffer,
      handleEndAudio,
      handleAudioError,
      handleSetAudioProgress,
    } = this.props;

    audioPlayer.onerror = () => {
      switch (audioPlayer.error.code) {
        case audioPlayer.error.MEDIA_ERR_ABORTED:
          handleAudioError("You have aborted the audio playback.");
          break;
        case audioPlayer.error.MEDIA_ERR_NETWORK:
          handleAudioError(
            "A network error caused the audio download to fail."
          );
          handleEndAudio({withError: true, errorMessage: "A network error caused the audio download to fail."});
          break;
        case audioPlayer.error.MEDIA_ERR_DECODE:
          handleAudioError(
            "The audio playback was aborted due to a corruption or the audio used features your browser did not support."
          );
          handleEndAudio({withError: true, errorMessage: "The audio playback was aborted due to a corruption or the audio used features your browser did not support."});
          break;
        case audioPlayer.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
          handleAudioError(
            "The audio has not loaded due to server or network failure."
          );
          handleEndAudio({withError: true, errorMessage: "The audio has not loaded due to server or network failure."});
          break;
        default:
          handleAudioError("Unknown error.");
          handleEndAudio({withError: true, errorMessage: "Unknown error."});
          break;
      }
      audioPlayer.volume = getPlayerVolume() / 100;
    };

    audioPlayer.onprogress = () => {
      if (audioPlayer && audioPlayer.buffered.length > 0) {
        const bufferEnd = audioPlayer.buffered.end(
          audioPlayer.buffered.length - 1
        );
        var bufferProgress = Math.trunc(
          (bufferEnd * 100) / audioPlayer.duration
        );
        handleSetAudioBuffer({
          bufferTime: bufferEnd,
          bufferProgress: bufferProgress,
          playDuration: audioPlayer.duration,
        });
      }
    };

    audioPlayer.onended = () => {
      if (audioPlayer) {
        handleEndAudio();
      }
    };

    audioPlayer.ontimeupdate = () => {
      if (audioPlayer && audioPlayer.currentTime) {
        var playProgressCalc = Math.trunc(
          (audioPlayer.currentTime * 100) / audioPlayer.duration
        );
        if (playProgress !== playProgressCalc) {
          if (!isBufferCompleted) {
            const bufferEnd = audioPlayer.buffered.end(
              audioPlayer.buffered.length - 1
            );
            var bufferProgress = Math.trunc(
              (bufferEnd * 100) / audioPlayer.duration
            );
            handleSetAudioProgress({
              playTime: audioPlayer.currentTime,
              playProgress: playProgressCalc,
              bufferTime: bufferEnd,
              bufferProgress: bufferProgress,
              playDuration: audioPlayer.duration,
            });
          } else {
            handleSetAudioProgress({
              playTime: audioPlayer.currentTime,
              playProgress: playProgressCalc,
              playDuration: audioPlayer.duration,
            });
          }
        }
      }
    };
  }

  handleCloseAbuseMsg = (abuseFlag) => {
    this.props.handleCloseAbuseMsg(); 
    activityLimitActions(abuseFlag);
  }

  trackId = null;

  render() {
    const {
      isPopOut, 
      classes,
      player: {
        tracksLoading,
        isAssetLoading,
        track,
        isLoop,
        isPlaying,
        isAudioError,
        errorMessage,
        audioPlayer,
        playableType,
        snackbar: { snackbarMessage }, 
        popoutFor,
        playObject
      },
      handleLoopPlay,
      handleUnloopPlay,
      handlePlayAudio,
      handlePauseAudio,
      plId,
    } = this.props;

    const performers = !track?.performer ? [] : (Array.isArray(track.performer) ? track.performer : [track.performer]);
    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            {track && track?.abuseMsg ? (
              <Confirm
                name="abuseDialog"
                classes
                isOpen={track?.abuseMsg ? true : false}
                title="Warning"
                innerHtmlContent={track?.abuseMsg}
                confirm="OK"
                // cancel=""
                onConfirm={() => this.handleCloseAbuseMsg(track?.abuseFlag)}
                // onCancel={}
              />
            ):("")
            }

           <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={snackbarMessage ? true : false}
              message={snackbarMessage}
              className={classes.snackbar}
            />
            <div className={classes.playerContainer}>
              {/* <div>
                {track && track?.prodArtworkUrl ? (
                  <Avatar
                    variant="square"
                    className={classes.square}
                    src={AuthSrc(track.prodArtworkUrl)}
                  />
                ) : (
                  <Avatar variant="square" className={classes.square}>-</Avatar>
                )}
              </div> */}
              <div className={classes.PlayerControls}>
                {track ? ( isAssetLoading ? (<IconButton
                        aria-label={t("player.pauseButton")}
                        title={t("player.pauseButton")}
                        className={classes.PlayerControlsBg}
                      >
                        <CircularProgress  />
                      </IconButton>) : (
                  isPlaying ? (
                    isAudioError ? (
                      <Badge
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        overlap="circle"
                        aria-label={t("player.error")}
                        title={t("player.error") + ": " + errorMessage}
                        badgeContent={"!"}
                        color="secondary"
                      >
                        <IconButton
                          aria-label={t("player.pauseButton")}
                          title={t("player.pauseButton")}
                          onClick={() => handlePauseAudio()}
                          className={classes.PlayerControlsBg}
                        >
                          <PauseIcon />
                        </IconButton>
                      </Badge>
                    ) : (
                      <IconButton
                        aria-label={t("player.pauseButton")}
                        title={t("player.pauseButton")}
                        onClick={() => handlePauseAudio()}
                        className={classes.PlayerControlsBg}
                      >
                        <PauseIcon />
                      </IconButton>
                    )
                  ) : isAudioError ? (
                    <Badge
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      overlap="circle"
                      aria-label={t("player.error")}
                      title={t("player.error") + ": " + errorMessage}
                      badgeContent={"!"}
                      color="secondary"
                    >
                      <IconButton
                        aria-label={t("player.playButton")}
                        title={t("player.playButton")}
                        onClick={() => handlePlayAudio(null)}
                        className={classes.PlayerControlsBg}
                      >
                        <PlayArrowIcon />
                      </IconButton>
                    </Badge>
                  ) : (
                    <IconButton
                      aria-label={t("player.playButton")}
                      title={t("player.playButton")}
                      onClick={() => handlePlayAudio(null)}
                      className={classes.PlayerControlsBg}
                    >
                      <PlayArrowIcon />
                    </IconButton>
                  )
                )) : (
                  <IconButton
                    aria-label={t("player.playButton")}
                    title={t("player.playButton")}
                    className={classes.DisabledPlayerControlsBg}
                  >
                    <PlayArrowIcon />
                  </IconButton>
                )}
              </div>
              <div className={classes.trackName}>
                {!isPopOut && (
                  <>
                    <span
                      aria-label={ track?.trackTitle
                        ? t("player.trackTitle") + " is " + track.trackTitle
                        : null}
                      title={
                        track?.trackTitle
                          ? t("player.trackTitle") + ": " + track.trackTitle
                          : null
                      }
                      className={classes.NowPlaying}
                    >
                      {track?.trackTitle ? track.trackTitle : "N/A"}
                    </span>
                    <span
                      aria-label={track?.performer
                        ? t("player.performer") + " is " + track.performer
                        : t("player.performer")}
                      title={
                        track?.performer
                          ? t("player.performer") + ": " + track.performer
                          : null
                      }
                      className={classes.CurrentPlaying}
                    >
                      {performers && (performers.map((data, i, array) => (
                        <Link
                        style={{ textDecoration: "none", color: "#fff" }}
                        key={i}
                        aria-label={"Open link"}
                        title={data}
                        to={{
                        pathname: `/search/tracks/${encodeURI(data.trim().replace("/", ""))}/performer`,
                        state:{
                        q:`${data.trim()}`,
                        autofocus:false
                        }
                      }}
                      >
                        <strong class="tablesLink">{data}{performers.length !== i+1?', ':''}</strong>
                      </Link>
                      )))}
                    </span>
                  </>
                )}
                <div
                  aria-label={t("player.playProgress")}
                  className={clsx("popupProgress",classes.PlayerProgress)}
                  title={t("player.playProgress")}
                >
                  <PlayerProgress
                    locate={(time) => {
                      if (
                        !audioPlayer.paused &&
                        audioPlayer.buffered.length > 0
                      ) {
                        audioPlayer.currentTime = time;
                      }
                    }}
                  />
                </div>
              </div>

              {isLoop ? (
                <IconButton
                  aria-label={t("player.repeatButton")}
                  title={t("player.repeatButton")}
                  onClick={() => handleUnloopPlay()}
                >
                  <RepeatIcon />
                </IconButton>
              ) : (
                <IconButton
                  aria-label={t("player.noRepeatButton")}
                  title={t("player.noRepeatButton")}
                  onClick={() => handleLoopPlay()}
                >
                  <RepeatOneIcon />
                </IconButton>
              )}
              <div
                aria-label={t("player.volume")}
                className={classes.PlayerVolume}
              >
                <PlayerVolume />
              </div>
              {!isPopOut && playableType !== PlayableTypes.track ? (
                <div
                  aria-label={t("player.playlist")}
                  className={classes.PlayerPlaylist}
                >
                  { tracksLoading ? <CircularProgress  /> : <PlayerPlaylist {...this.props} /> }
                </div>
              ) : null}
              { !isPopOut && (
                <div className={classes.playerDownload}>
                  <DownloadLink track={track}  plId={playableType == PlayableTypes.playlist? playObject?.id : null} />
                </div>
              ) }
              { (!isPopOut && track && popoutFor) && (
                <div className={classes.popOutBlock}>{<MetaDataPopOut data={track}/>}</div>
              ) }
            </div>
          </>
        )}
      </Translation>
    );
  }
}

Player.propTypes = {
  player: PropTypes.object.isRequired,
  handlePlayAudio: PropTypes.func.isRequired,
  handlePauseAudio: PropTypes.func.isRequired,
  handleClearAudio: PropTypes.func.isRequired,
  handleSetAudioProgress: PropTypes.func.isRequired,
  handleSetAudioBuffer: PropTypes.func.isRequired,
  handleLoopPlay: PropTypes.func.isRequired,
  handleUnloopPlay: PropTypes.func.isRequired,
  handleEndAudio: PropTypes.func.isRequired,
  handleAudioError: PropTypes.func.isRequired,
  handleCloseAbuseMsg: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    handlePlayAudio: (payload) => dispatch(playAudio(payload)),
    handlePauseAudio: () => dispatch(pauseAudio()),
    handleClearAudio: () => dispatch(clearAudio()),
    handleSetAudioProgress: (payload) => dispatch(setAudioProgress(payload)),
    handleSetAudioBuffer: (payload) => dispatch(setAudioBuffer(payload)),
    handleLoopPlay: () => dispatch(loopPlay()),
    handleUnloopPlay: () => dispatch(unloopPlay()),
    handleEndAudio: (payload) => dispatch(endAudio(payload)),
    handleAudioError: (payload) => dispatch(audioError(payload)),
    handleCloseAbuseMsg: (payload) => dispatch(abuseMsgClose(payload)),
    handlePlayPlaylistTrack: (payload) => dispatch(playPlaylistTrack(payload))
  };
};

const mapStateToProps = (state) => ({
  player: state.player,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Player));
